var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "notifications" },
    [
      _c("div", {
        staticClass: "ui centered inline loader",
        class: { active: _vm.form.waiting },
      }),
      _vm._v(" "),
      _c("pagination", { attrs: { pager: _vm.pager, callback: _vm.search } }),
      _vm._v(" "),
      _c("table", { staticClass: "ui striped table" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.shops, function (shop) {
            return _c("tr", { key: shop.id }, [
              _c("td", [
                _c(
                  "a",
                  {
                    staticClass: "clickable",
                    attrs: { href: shop.auth_url, target: "_blank" },
                  },
                  [_vm._v(_vm._s(shop.name))]
                ),
              ]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(shop.unread_count) + "件")]),
            ])
          }),
          0
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("店舗名")]),
        _vm._v(" "),
        _c("th", [_vm._v("未読通知数")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }